import React from 'react';

// Components
import SurfaceItemAvatar from '../SurfaceItemAvatar';

// Utils
import { getTimeAgoLabel } from 'Shared/utils/DateTime.utils';

// Styles
import '../SurfaceItemDetails.scss';

type Props = {
  surfaceItem;
};

const GoogleItemDetails = ({ surfaceItem }: Props) => {
  const createdByUserId = surfaceItem.details_panel.created_id;
  const createdByUserName = surfaceItem.details_panel.created_name;
  const updatedByUserId = surfaceItem.details_panel.updated_id;
  const updatedByUserName = surfaceItem.details_panel.updated_name;
  const lastUpdatedTime = surfaceItem.details_panel.updated_at ? surfaceItem.details_panel.updated_at : null;
  const lastUpdatedDisplay = lastUpdatedTime ? getTimeAgoLabel(new Date(lastUpdatedTime * 1000)) : null;
  const baseClassName = 'SurfaceItemDetails__content';
  return (
    <div className={`${baseClassName}`}>
      {(createdByUserId || createdByUserName) && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Created by:</div>
          <div className={`${baseClassName}__row__value`}>
            <SurfaceItemAvatar userId={createdByUserId} displayName={createdByUserName} />
          </div>
        </div>
      )}
      {(updatedByUserId || createdByUserName) && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Last updated by:</div>
          <div className={`${baseClassName}__row__value`}>
            <SurfaceItemAvatar userId={updatedByUserId} displayName={updatedByUserName} />
          </div>
        </div>
      )}
      {lastUpdatedDisplay && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Last updated:</div>
          <div className={`${baseClassName}__row__value`}>
            <div className={`${baseClassName}__row__value__text`}> {lastUpdatedDisplay}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoogleItemDetails;
